import { Heading, Text } from "@athena/ui";
import type { ReactNode } from "react";

interface PageSectionProps {
    title?: string;
    description?: string;
    children: ReactNode;
    className?: string;
}

/**
 * Reusable page section with optional title and description
 */
export function PageSection({ title, description, children, className = "" }: PageSectionProps) {
    return (
        <section className={`space-y-6 ${className}`}>
            {(title || description) && (
                <div className="space-y-2">
                    {title && (
                        <Heading level={3} className="text-3xl font-bold tracking-tight">
                            {title}
                        </Heading>
                    )}
                    {description && <Text className="text-muted-foreground text-lg">{description}</Text>}
                </div>
            )}
            {children}
        </section>
    );
}
